export enum ResultsView {
  Details,
  Summary,
  Input,
  MatchedProducts,
  ViewAllProducts,
  ComparedProducts,
}

